/** The transport awaits this boundary before every adapter invocation, including
 * chat and retries. CLI evaluations have no browser persistence to flush. */
let guard: (() => Promise<void>) | null = null
export function setPaidCallDurabilityGuard(next: (() => Promise<void>) | null): void {
  guard = next
}
export async function beforePaidCall(): Promise<void> {
  await guard?.()
}
